/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Paper, PaperProps } from '@mui/material';
import React from 'react';
import appTheme from './theme/appTheme.json';

export interface CustomPaperProps {}

const CustomPaper = (props: JSX.IntrinsicAttributes & PaperProps) => {
  return (
    <React.Fragment>
      <Paper
        sx={{
          backgroundColor: appTheme.secondaryBackgroundColor,
          color: appTheme.primaryTextColor,
        }}
        {...props}
        square={true}
      />
    </React.Fragment>
  );
};

export default CustomPaper;
